<template>
  <div>
    <div class="design_box_out">
      <p class="design_box_out_title"><i class="iconfont iconyou"></i>{{property.label}}</p>
      <div class="mycard-desc design_box">
        <div class="mycard-desc-list" v-for="(item,index) in property.list" :key="index">
          <div class="mycard-desc-list-left">
            <div class="mycard-desc-list-top">
              <p class="mycard-desc-list-name">{{item.name}}</p>
              <p class="mycard-desc-list-company">{{item.position}}</p>
            </div>
            <p class="mycard-desc-list-phone"><i class="iconfont icondianhua"></i>{{item.mobile}}</p>
          </div>
          <div class="mycard-desc-list-img"
               :style="{backgroundImage:'url('+item.pic+')',backgroundSize:'cover',backgroundPosition:'center'}"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ["property"],
    data() {
      return {
        form: {}
      };
    },
    created() {
    }
  };
</script>



